import { Component, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { StopService } from '../../../@core/services/stop.service';
import { OptimizationService } from '../../../@core/services/optimization.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DTOOptimizationResult } from '../../../@core/models/dto-optimizationresult';

@Component({
  selector: 'ngx-optimize-dialog',
  templateUrl: 'optimize-dialog.component.html',
  styleUrls: ['./optimize-dialog.component.scss']
})
export class OptimizeDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<OptimizeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _stopService: StopService,
    private OptimService: OptimizationService,
    private ngZone: NgZone
  ) {}

  public OptimizeRoute() {
    this.ngZone.run(() => {
      this.dialogRef.close();
    });
    this._stopService.setLoadingInProgress(true);
    this.OptimService.ReoptimizeRoute(
      this._stopService.RouteDate,
      this._stopService.RouteID.toString()
    ).subscribe(
      (success: DTOOptimizationResult) => {
        this._stopService.setLoadingInProgress(false);
      },
      (err: HttpErrorResponse) => {
        this._stopService.setLoadingInProgress(false);
        this._stopService.currentStopsSubject.next(null);
      }
    );
  }
}
